import React, {
  useState,
  useCallback,
  useReducer,
  useEffect,
  useRef,
} from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import dayjs from "dayjs";

import currentUserToken from "CurrentUserToken";
import { I18n } from "aws-amplify/utils";
import { APIStatusDialog } from "components/APIStatusDialog";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Divider,
  Grid,
  Stack,
  TextField,
  Typography,
  Input,
  IconButton,
  InputAdornment,
} from "@mui/material";

import { DataGrid } from "@mui/x-data-grid";
import columns from "./columns";
import DeleteSimulationModal from "layouts/dashboard/chart/modal/confirmDeleteSimulation";
import { hrGetSimulation } from "layouts/dashboard/apiService";
import { hrGetSimulationInfo } from "layouts/dashboard/apiService";
import { useNavigate } from "react-router-dom";
import { hrPostDeleteSimulation } from "layouts/dashboard/apiService";
import AlertPopup from "layouts/dashboard/chart/modal/alertPopup";
import FullscreenLoader from "components/FullscreenLoader";
import { saveSimulationData } from "layouts/dashboard/indexedDbUtils";
import SearchIcon from "@mui/icons-material/Search";

const reducer = (lastState, action) => {
  switch (action.type) {
    case "LOADING":
      return {
        ...lastState,
        searchFetched: false,
      };

    case "DATA_RECEIVED":
      const audit = action.value;
      if (Array.isArray(audit)) {
        audit.forEach((element) => {
          if (typeof element.timestamp === "number") {
            element.timestamp = dayjs(element.timestamp).format(
              "YYYY-MM-DD HH:mm"
            );
          }
        });
        return {
          audit: audit,
          fetched: true,
          searchFetched: true,
          lastUpdate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        };
      }
      break;

    default:
      return lastState;
  }
};

function History() {
  const [state, dispatch] = useReducer(reducer, {
    audit: [],
    fetched: false,
    searchFetched: false,
    lastUpdate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
  });
  const [apiStatus, setApiStatus] = useState({
    open: false,
    status: "",
    message: "",
  });

  /* -------------------------------------------------------- USESTATE -------------------------------------------*/

  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "en"
  );
  const navigate = useNavigate();

  const [profile, setProfile] = useState([]);
  const [openDeleteSimulationModal, setOpenDeleteSimulationModal] =
    useState(false);
  const [selectedSimulation, setSelectedSimulation] = useState("");
  const [data, setData] = useState([]);
  const [openAlert, setOpenAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertTitle, setAlertTitle] = useState("");
  const [tableHeight, setTableHeight] = useState(0);
  //loading
  const [loading, setLoading] = useState(false);
  const [fullLoading, setFullLoading] = useState(false);
  //filter
  const [searchQuery, setSearchQuery] = useState("");

  /* -------------------------------------------------------- API -------------------------------------------*/
  const fetchSimulations = async () => {
    setLoading(true);
    try {
      const data = await hrGetSimulation();
      setData(data);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSimulations();
  }, []);
  const [errorMotivation, setErrorMotivation] = useState("");
  const [dataref, setDataref]=useState([])
  const openSimulation = async (rowData) => {
    setFullLoading(true);
    try {
      const response = await hrGetSimulationInfo(rowData.id);
      const parsedData = response.map((item) => JSON.parse(item.card_content));
      const description = response[0]?.description || "";
      const owner1 = response[0]?.owner1 || "";
      const owner2 = response[0]?.owner2 || "";
      const owner3 = response[0]?.owner3 || "";
      //console.log("descrizione: ", description);
      //console.log("la 2 response è: ", response);
      //console.log("motivazione: ",errorMotivation)
      setDataref(parsedData)
      await saveSimulationData(parsedData);
      // localStorage.setItem("simulationData", JSON.stringify(parsedData));
      navigate(`/dashboard?simulationId=${rowData.id}`, {
        state: {
          fromSimulation: true,
          description: description,
          owner1: owner1,
          owner2: owner2,
          owner3: owner3,
        },
      });
    } catch (error) {
      //console.log("id della riga da aprire: ", rowData.id)
      //console.log("salvo simulation: ", dataref)
      console.log(error);
    } finally {
      setFullLoading(false);
    }
  };

  const handleDeleteSimulation = async () => {
    //console.log("selected: ", selectedSimulation);
    if (selectedSimulation == "") return;
    try {
      const response = await hrPostDeleteSimulation(selectedSimulation);
      showAlert("Simulation deleted successfully", "Success");
    } catch (error) {
      console.log(error);
    }
    setSelectedSimulation("");
    setOpenDeleteSimulationModal(false);
    fetchSimulations();
  };

  /* -------------------------------------------------------- HANDLERS -------------------------------------------*/

  const showAlert = (message, severity) => {
    setAlertTitle(severity);
    setAlertMessage(message);
    setOpenAlert(true);
    setTimeout(() => {
      setOpenAlert(false);
    }, 3000);
  };

  const deleteClick = (simulationId) => {
    setSelectedSimulation(simulationId);
    setOpenDeleteSimulationModal(true);
  };

  /* -------------------------------------------------------- BROWSER VIEW -------------------------------------------*/

  function getBrowserName() {
    const userAgent = navigator.userAgent;
    if (userAgent.includes("Firefox")) {
      return "Firefox";
    } else if (userAgent.includes("Edg")) {
      return "Edge";
    }
  }
  const browser = getBrowserName();
  useEffect(() => {
    if (browser === "Firefox") {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "auto";
      };
    }
  }, []);

  useEffect(() => {
    const updateHeight = () => {
      const navbarHeight = document.getElementById("navbar");
      const footerHeight = document.getElementById("footer");
      const availableHeight =
        document.documentElement.clientHeight -
        navbarHeight -
        footerHeight -
        90;
      setTableHeight(availableHeight);
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  /* -------------------------------------------------------- FILTERS -------------------------------------------*/

  const filterRows = (data, searchQuery) => {
    //funzione di filtro generico
    if (!searchQuery || searchQuery.trim() === "") return data;

    const query = searchQuery.toLowerCase();

    return data.filter((row) =>
      Object.entries(row).some(([key, value]) => {
        if (typeof value === "string" || typeof value === "number") {
          return String(value).toLowerCase().includes(query);
        }
        return false;
      })
    );
  };
  const filteredRows = filterRows(data, searchQuery);

  /* -------------------------------------------------------- JSX -------------------------------------------*/
  return (
    <>
      <DashboardLayout>
        <DashboardNavbar
          absolute
          light
          language={language}
          setLanguage={setLanguage}
          setProfile={setProfile}
        />

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box sx={{ p: 2, maxHeight: `${tableHeight}px` }}>
              <Card
                sx={{
                  p: 3,
                  maxHeight: `${tableHeight}px`,
                }}
              >
                <Stack
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 1,
                  }}
                >
                  <FullscreenLoader loading={fullLoading} />
                  <Box>
                    <Typography variant="h4">
                      {I18n.get("Simulations")} ({filteredRows.length})
                    </Typography>
                  </Box>
                  <Box>
                    <Input
                      type="text"
                      placeholder={I18n.get("Search")}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      sx={{
                        "& .MuiInputBase-input": {
                          padding: "12px 0px  12px  12px  ",
                        },
                        "& .MuiFormControl-root-MuiTextField-root": {
                          marginTop: "0px",
                        },
                        maxWidth: "200px",
                        mb: 2,
                        mt: 2,
                      }}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton>
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </Box>
                </Stack>

                <DataGrid
                  columns={columns(deleteClick, openSimulation)} //passo la struttura delle colonne
                  rows={filteredRows} //passo le righe filtrate
                  sx={{ minHeight: "200px" }}
                  loading={loading} //loading integrato
                  disableMultipleRowSelection
                  hideFooter
                />
              </Card>
            </Box>
          </Grid>
        </Grid>
        <DeleteSimulationModal
          open={openDeleteSimulationModal}
          onClose={() => setOpenDeleteSimulationModal(false)}
          selectedSimulation={selectedSimulation}
          onSubmit={handleDeleteSimulation}
        />
        <AlertPopup
          open={openAlert}
          onClose={() => setOpenAlert(false)}
          alertTitle={alertTitle}
          alertMessage={alertMessage}
        />
      </DashboardLayout>
    </>
  );
}

export default History;
